import * as coupon from './coupon';
import * as customer from './customer';
import * as license from './license';
import * as product from './product';
import * as tutorial from './tutorial';
import * as tutorialSection from './tutorialSection';
import * as user from './user';


// Assemble configurations
const configurations : any = {
    "coupon": coupon,
    "customer": customer,
    "license": license,
    "product": product,
    "tutorial": tutorial,
    "tutorialSection": tutorialSection,
    "user": user
}

// Export configurations
export default configurations;
